// This is how a normal module looks like. You can copy paste this
// for any new module you want to create. Then you can import it in
// main.js and call "init()" to execute the code.


const Header = ((($) => {

  let sticky;
  let scroll;
  function init() {
    $(window).scroll(scrollFunction);
    $('.mobile-nav-link').on('click', toggleNav);
  }

  function toggleNav() {
    $('.Header').toggleClass('show-nav');
  }

  function scrollFunction() {
    sticky = $('.Header');
    scroll = $(window).scrollTop();

    if (scroll >= 10) sticky.addClass('fixed');
    else sticky.removeClass('fixed');
  }

  return {
    init,
  };
}))(jQuery);


// don't forget to export
export default Header;



// WEBPACK FOOTER //
// ./src/static/js/modules/header.js